var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowThinWhite = function SvgArrowThinWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "54 140.9949951 306.0050049 512.0050049",
    style: {
      fill: "white"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330.1081543,382.9781494L111.9408112,164.8107758c-7.7545395-7.7545471-20.2895432-7.7545471-28.044075,0 c-7.7545319,7.7545319-7.7545319,20.2895355,0,28.0440674l204.1448669,204.1448517L83.8967285,601.1445313 c-7.7545395,7.7545776-7.7545395,20.2895508,0,28.0441284c3.8675079,3.8674927,8.9445419,5.8114624,14.0225067,5.8114624 c5.077034,0,10.1549988-1.9439697,14.0225067-5.8114624l218.1673584-218.1674194 C337.8627014,403.2676697,337.8627014,390.732666,330.1081543,382.9781494z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowThinWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "arrow-thin-white.1a1040eb1f0e091b087da20572a92031.svg";